// Generated by OrchestKit Claude Plugin
// Created: 2026-09-11

/**
 * Libellés des modes de règlement — RG-081.
 *
 * Une valeur inconnue est rendue TELLE QUELLE, jamais remplacée par un tiret :
 * un mode ajouté au serveur et pas encore connu ici doit rester lisible.
 * L'effacer ferait disparaître de l'écran un règlement bien réel.
 */
const MODES: Record<string, string> = {
  ESPECES: 'Espèces',
  MOBILE_MONEY: 'Mobile Money',
  VIREMENT: 'Virement',
  CHEQUE: 'Chèque',
};

export function libelleMode(mode: string): string {
  return MODES[mode] ?? mode;
}
